import React from 'react';

import { css } from '@emotion/css';
import { Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { ConditionType } from '@/models/ConditionModel.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { ControlledDateField } from '@/uiKit/molecules/ControlledDateField.tsx';

export type TermDateFieldProps = {
  className?: string;
};

export const TermDateField: React.FC<TermDateFieldProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const diabetesType = useWatch({
    name: 'diabetesType',
  }) as ConditionType | undefined;

  if (diabetesType !== 'gestational') {
    return null;
  }

  return (
    <div className={className}>
      <div className={styles.subtitle}>
        <Typography variant="subtitle">
          {t('diabetesForms.termDate')}
        </Typography>
      </div>
      <ControlledDateField id="tls-term-date-input" name="termDate" required />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  subtitle: css({
    marginBottom: theme.spacing(12),
  }),
});
